import React from 'react';
import { useIntl } from 'react-intl';

import { translateApiProperty } from '@hisports/common';

import { formatDateRange, isLeague } from "../lib"

export default ({ schedule, locale }) => {
  const { formatMessage } = useIntl();

  const category = translateApiProperty(schedule.category, 'name', locale);
  const gender = formatMessage({ id: `common.enums.genders.${schedule.category.gender}` })

  if (isLeague(schedule)) {
    const season = schedule.type !== 'League' ?
      formatMessage({ id: `common.enums.scheduletypes.${schedule.type}` }) :
      formatMessage({ id: 'common.lang.regularseason' });
    return <>{category} {gender} - {season}</>;
  }

  return <>{category} {gender} - {formatMessage({ id: `common.enums.scheduletypes.${schedule.type}` })} - {formatDateRange(schedule.startDate, schedule.endDate, locale, 'UTC')}</>
}
